import { z } from "zod";
import { OrchestrationCriteria } from "../../shared/domain/orchestrationCriteria.entity";
import {
  actionsMapSchema,
  createEmptyCriteria,
  orchestratedEntityBaseSchema,
} from "../../shared/domain/orchestratedEntity.schema";

export const ScenarioSchema = z.object({
  ...orchestratedEntityBaseSchema,
  name: z.string(),
  engineMultiConfigId: z.string().optional(),
  globalActions: actionsMapSchema,
});

export type ScenarioInput = z.input<typeof ScenarioSchema>;
export type ScenarioEntity = z.output<typeof ScenarioSchema>;
export type { OrchestrationCriteria };

export function createEmptyScenario(id: string): ScenarioEntity {
  return {
    id,
    active: true,
    ticker: "",
    name: "",
    engineMultiConfigId: "",
    globalActions: {},
    criteria: createEmptyCriteria(),
  };
}
